import { render, staticRenderFns } from "./Starred.vue?vue&type=template&id=35f27fb5&"
import script from "./Starred.vue?vue&type=script&lang=ts&"
export * from "./Starred.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports